import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateFarmCreditAllotments } from "services";

import { GET_FARM_AREA_SUMMARY, UPDATE_FARM_CREDIT_ALLOTMENTS } from "consts";

import { Message as message } from "components";

export const useUpdateFarmCreditAllotments = ({ farmId }: { farmId: string }) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [UPDATE_FARM_CREDIT_ALLOTMENTS],
    mutationFn: updateFarmCreditAllotments,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_FARM_AREA_SUMMARY, farmId] });
      message({
        icon: "tick",
        content: "Allotments successfully updated",
      });
    },
  });
};
